import type { PropsWithChildren } from "react";

export function FullScreenLayout({ children }: PropsWithChildren) {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-grass">
      <div className="min-h-0 grow basis-0">{children}</div>
    </div>
  );
}
